<template>
  <div class="flex flex-col">
    <div class="t-header bg-primary2 py-2 rounded-t-lg">
      <div
        class="h-item flex justify-center items-center bold text-white gap-x-2"
      >
        <span class="text-small"> Masa {{ currentCart.name }} </span>
        <i class="feather icon-arrow-right"></i>
        <span>{{ toTableName }}</span>
      </div>
    </div>
    <div class="t-body flex flex-col">
      <label
        class="item-row grid py-4 pr-2 items-center"
        v-for="(paymentGroup, index) in currentCart.paymentGroups"
        :key="paymentGroup.rowIndex"
        :for="paymentGroup.rowIndex"
      >
        <input
          class="checkbox"
          :id="paymentGroup.rowIndex"
          type="checkbox"
          v-model="selected[index]"
          :disabled="$isRowPaid(paymentGroup)"
        />
        <vs-row>
        <vs-td class="w-5/12">
                  <vs-row
                    vs-type="block"
                    vs-w="12"
                    v-for="entry in paymentGroup.entries"
                    :key="entry.id"
                  >
                    <p class="text-center tr-text text-primary">
                      {{
                        entry.productName +
                        (entry.quantity > 1 ? " - x" + entry.quantity : "")
                      }}
                    </p>
                    <p
                      v-show="
                        rawmaterial.selected && rawmaterial.isDefault == false
                      "
                      v-for="(rawmaterial, rawMaterialIndex) in entry.recipe
                        .steps"
                      :key="rawMaterialIndex"
                      class="text-center tr-text-child text-primary"
                    >
                      {{ rawmaterial.name }}
                    </p>
                  </vs-row>
                </vs-td>
                <vs-td class="w-4/12">
                  <vs-row
                    vs-type="block"
                    vs-w="12"
                    v-for="entry in paymentGroup.entries"
                    :key="entry.rowId"
                  >
                    <span
                      class="tr-text-child text-center text-primary"
                      v-for="extra in entry.extras"
                      :key="extra.id"
                    >
                      <p
                        class="product-extra text-primary"
                        v-if="extra.quantity > 0 && extra.variants.length == 0"
                      >
                        x{{ extra.quantity }} | {{ extra.name }}
                      </p>
                      <p
                        style="display: block"
                        class="product-extra text-primary"
                        v-else-if="extra.variants.length > 0"
                        v-for="seletedVariantExtra in returnSelectedExtraVariant(
                          extra
                        )"
                        :key="seletedVariantExtra"
                      >
                        {{ seletedVariantExtra }}
                      </p>
                    </span>
                  </vs-row>
                </vs-td>
                <vs-td class="w-auto">
                  <vx-tooltip
                    v-if="
                      paymentGroup.entries.some(
                        (x) => x.originPrice != x.price && x.originPrice
                      )
                    "
                    :text="getTotalGift(paymentGroup) + 'İndirim'"
                    position="top"
                  >
                    <feather-icon
                      icon="GiftIcon"
                      svgClasses="h-5 w-5"
                      class="text-success"
                    />
                  </vx-tooltip>
                  <span
                    v-if="paymentGroup.payedPrice > 0 && paymentGroup.payedPrice != paymentGroup.totalPrice"
                    class="text-center text-primary tr-text w-full line-through"
                  >
                    {{ $toCurrency(paymentGroup.totalPrice) }}
                  </span>
                  <p
                    class="text-center text-primary tr-text w-full"
                    :class="{ 'payed-row': $isRowPaid(paymentGroup) }"
                  >
                    {{
                      !$isRowPaid(paymentGroup)
                        ? $toCurrency(paymentGroup.totalPrice - paymentGroup.payedPrice)
                        : "Ödendi"
                    }}
                    ₺
                  </p>
                </vs-td>
              </vs-row>
      </label>
    </div>
    <div class="sticky bottom-0 flex pb-4 mt-4 bg-white">
      <vs-button
        type="gradient"
        :disabled="
          lossMode && lossTypeSelection
            ? selectedLossStocks.length == 0
            : currentCart.cartEntries.length == 0
        "
        class="w-full md:w-auto ml-0 md:ml-auto"
        color="primary"
        id="t-done"
        @click="PlaceOrder()"
      >
        Transferi Tamamla
      </vs-button>
    </div>
  </div>
</template>

<script>
import QrReader from "./QrReader.vue";
import LossReasonSelect from "./LossReasonSelect.vue";
import OrderList from "./OrderList.vue";
import CakeQuestion from "./CakeQuestion.vue";
import { setBranchCart, removeToCart, removeToCartIds } from "@/api/Cart";
import { uuid } from "vue-uuid";
export default {
  props: {
    toTableName: "",
  },
  data() {
    return {
      baskets: [],
      basketCount: 0,
      selected: [],
      moment: require("moment-timezone"),
      currentTime: "",
      isNotePopupOpen: false,
      selectedNote: "",
      tableHeight: "100% !important",
    };
  },
  components: {
    OrderList,
    CakeQuestion,
    LossReasonSelect,
    QrReader,
  },
  mounted() {
    this.getCurrentTime();
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val.id && !this.lossMode) {
          //this.$store.dispatch("selfservice/setToUpdateEntry", null)
          this.$store.dispatch("selfservice/setSelectedProduct", null);
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          this.$nextTick(() => {
            this.$store.dispatch("selfservice/setToUpdateEntry", val);
          });
        }
      },
    },
    toUpdateEntry(val) {
      if (!val) this.selected = "";
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768; // Adjust the width as needed for mobile
    },
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      const cart = this.$store.getters["selfservice/getCurrentCart"];
      return cart;
    },
    carts: function () {
      return this.$store.getters["selfservice/getCarts"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set() {
        this.$store.dispatch("selfservice/setActivePersonal");
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM");
      return date;
    },
    currentTab: {
      get() {
        return this.$store.getters["selfservice/getCurrentTab"];
      },
    },
  },
  methods: {
    getTotalGift(row) {
      let totalGift = row.entries.reduce(function (total, num) {
        if (num.originPrice - num.price > 0)
          return total + (num.originPrice - num.price);
        else return total + 0;
      }, 0);
      return this.$toCurrency(totalGift);
    },
    openNotePopup(note) {
      this.selectedNote = note;
      this.isNotePopupOpen = true;
    },
    clearQr() {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", null);
    },
    commitQrCode(customer) {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
    },
    openQrReader() {
      this.$refs.qrReader.isActive = true;
    },
    submitLoss: function () {
      let obj = {
        stockEntries: this.selectedLossStocks,
        branchId: 0,
        userId: 0,
        type: "Stock",
      };
      this.$refs.lossReasonSelect.isActive = true;
      this.$refs.lossReasonSelect.lossData = obj;
    },
    clearLossList() {
      if (this.selected.id)
        this.$store.dispatch(
          "selfservice/removeSelectedLossStock",
          this.selected.id
        );
      else this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.selected = "";
    },
    setBillExtras(extras) {
      let returnObj = [];
      extras.forEach((x) => {
        if (x.quantity > 0) {
          returnObj.push(x);
        } else if (
          x.quantity == 0 &&
          x.variants != null &&
          x.variants.length > 0
        ) {
          x.variants
            .filter((y) => y.quantity > 0)
            .forEach((z) => {
              returnObj.push(z);
            });
        }
      });
      return returnObj;
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      extra.variants.forEach((x) => {
          returnObj.push("x" + x.quantity + " / " + x.name);
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    moveOnToOrderList() {
      this.$refs.cakeQuestion.isActive = false;
      this.$refs.orderList.isActive = true;
    },
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime
        .tz("Europe/Istanbul")
        .format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000);
    },
    ClearCart: async function () {
      if (this.currentCart.cartEntries.length > 0) {
        this.$store.dispatch(
          "selfservice/removeEntryFromCurrentCart",
          this.selected
        );
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
        let currentCart = this.$store.getters["selfservice/getCurrentCart"];
        currentCart.paymentGroups = currentCart.paymentGroups.filter(
          (x) => x.rowIndex != this.selected.rowIndex
        );
        if (this.$tableMode) {
          //await setBranchCart({value:currentCart, tableId: currentCart.tableId});
          await removeToCart(this.selected.rowIndex, currentCart.tableId);
        }
        // Masa haritasına geçiş için emit gönder
        //this.$emit('switchToTableMap');
      }
      if (this.currentCart.cartEntries.length == 0) {
        let currentCart = this.$store.getters["selfservice/getCurrentCart"];
        currentCart.paymentGroups = [];
        if (this.$tableMode) {
          await setBranchCart({
            value: currentCart,
            tableId: currentCart.tableId,
            remove: currentCart.notSeat,
          });
        }
        this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
        this.isCakeQuestioned = false;
        // Masa haritasına geçiş için emit gönder
        this.$emit("switchToTableMap");
        this.$vs.notify({
          color: "success",
          title: "Sepette ürün kalmadı.",
          text: "Sepette ürün kalmadığı için masa kapatıldı.",
        });
      }
    },
    PlaceOrder: async function () {
      this.$emit(
        "completeTransfer",
        this.selected
          .map((item, i) => (item === true ? i : null))
          .filter((i) => i !== null)
          .map((index) => this.currentCart.paymentGroups[index].rowIndex)
      );
      return;
    },
    sumOfExtraPrices(extras) {
      let sum = 0;
      extras.forEach((x) => {
        if (x.variants != null && x.variants.length > 0) {
          x.variants.forEach((y) => {
            sum += y.price * y.quantity;
          });
        } else {
          sum += x.price * x.quantity;
        }
      });
      return sum;
    },
    openNewBasket() {
      let id = this.carts.length;
      let newCart = {
        id: "n" + id.toString(),
        cartEntries: [],
        totalPrice: 0,
        active: true,
        tableNumber: "n" + id.toString(),
        tableId: uuid.v1(),
        paymentGroups: [],
        notSeat: true,
      };
      this.$store.dispatch("selfservice/createNewCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/setCakeQuestioned", false);
      this.$store.dispatch("selfservice/setCurrentCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$emit("handleTableSelection", {
        id: newCart.tableId,
        number: newCart.tableNumber,
      });
    },
    chanceCurrentCart(cart) {
      this.$store.dispatch("selfservice/setCurrentCart", cart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$emit("handleTableSelection", {
        id: cart.tableId,
        number: cart.tableNumber,
      });
    },
    switchToTableMap() {
      this.$emit("switchToTableMap");
    },
    sendOrder: async function (tr) {
      let tempCart = this.$store.getters["selfservice/getCurrentCart"];

      // Find the corresponding payment group and update isSend
      const paymentGroupIndex = tempCart.paymentGroups.findIndex(
        (group) => group.rowIndex === tr.rowIndex
      );

      if (paymentGroupIndex !== -1) {
        tempCart.paymentGroups[paymentGroupIndex].isSend = true;
        // Update the cart in the store
        await setBranchCart({ value: tempCart, tableId: tempCart.tableId });
        // Show a success toast notification
        this.$vs.notify({
          color: "success",
          title: "Sipariş Gönderildi",
          text: "Sipariş başarıyla gönderildi.",
        });
      }
    },
  },
};
</script>

<style>
.item-row {
  display: grid;
  grid-template-columns: 32px 1fr auto;
  transition: all 0.3s linear;
}
.item-row:nth-child(odd) {
  background-color: #6a1f1340;
}
.item-row:hover {
  transform: translateY(-4px);
}
.checkbox {
  accent-color: #6a1f13;
  width: 20px;
  height: 20px;
  margin: auto;
}

.product-name {
  font-weight: 600 !important;
}

.product-extra {
  font-weight: 400;
  font-style: italic;
  font-size: 0.75rem;
}

.sub-layer {
  font-size: 1rem;
  font-weight: 500 !important;
  line-height: 1.5rem;
  color: #0e0e0e;
  letter-spacing: 0.5px;
}

.basket-action {
  box-shadow: 1px 6px 4px #00000029;
  color: #804000;
  border-radius: 50%;
  width: 3.5rem !important;
  height: 3.5rem !important;
}

.basket-action i {
  font-size: 2rem !important;
  text-shadow: 1px 1px 5px gainsboro;
}

#order-done {
  border-radius: 15px;
  padding: 1rem 2rem !important;
  font-size: 1rem !important;
  font-weight: bold !important;
  letter-spacing: 0.5px;
}

#price-details {
  display: flex;
  flex-direction: column;
}

.price {
  font-weight: 600 !important;
  font-style: italic;
  font-size: 1.3vw;
  line-height: 1.1vw;
}

.label {
  font-size: 1.3vw;
  font-weight: 500 !important;
  line-height: 1.1vw !important;
}

@media (max-width: 768px) {
  .label {
    font-size: inherit;
    line-height: inherit !important;
  }
}

.align-center {
  text-align: center !important;
}

.img-border {
  border: 2px solid #000000;
  border-radius: 143px;
  border-color: #804000;
}

#empty-basket {
  height: 40vh;
  display: flex;
}

#cartEntryTable
  .con-tablex
  .vs-con-tbody
  .vs-table
  .vs-table--thead
  tr
  th
  .vs-table-text {
  border: none !important;
}

#cartEntryTable .con-tablex .vs-con-tbody {
  background-color: white;
  border: none !important;
}

#cartEntryTable .con-tablex .vs-con-tbody .vs-table tbody .tr-values {
  border: none !important;
  box-shadow: none !important;
}

.tablez {
  position: relative !important;
  box-shadow: 0px 3px 6px #00000029 !important;
}

.tablez .vs-table--content {
  height: 43vh;
  width: 42vw;
}

@media (max-width: 768px) {
  .tablez .vs-table--content {
    width: 100vw;
  }
}

#basket-group {
  position: absolute;
  left: -54px;
  top: 0;
  z-index: 10000;
  width: 53px;
}

#basket-actions {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 11rem;
  border-top: 0.1rem dotted #000000;
}

@media (max-width: 768px) {
  #basket-actions {
    height: 12.6rem;
  }
}

.basket-number {
  cursor: pointer;
  background-color: #ffffff !important;
  text-shadow: 0px 1px black;
  border-radius: 6px 0px 0px 6px;
  padding: 0 1rem !important;
  width: 42px !important;
  height: 40px !important;
  -webkit-box-shadow: 0 8px 6px -6px black;
  -moz-box-shadow: 0 8px 6px -6px black;
  box-shadow: 0px 8px 6px -6px black;
  margin-bottom: 0.2rem;
  margin-right: 0.1rem;
  float: right !important;
  font-size: 1.2rem !important;
}

.basket-number-active {
  background: transparent linear-gradient(180deg, #6a1f13 0%, #9a2411 100%) 0%
    0% no-repeat padding-box !important;
  color: #f1f1f1 !important;
}

.basket-plus {
  background-color: #ffffff !important;
  box-shadow: -7px 2px 6px #00000029;
  border-radius: 8px 0px 0px 8px;
  border-right: none;
  width: 60px !important;
  height: 30px !important;
  margin-right: -4px;
  float: right !important;
  padding: 0 !important;
}

.basket-plus i {
  font-size: 1.2rem !important;
  font-weight: 600 !important;
}

.product-name {
  font-weight: 400;
}
.vs-popup--content {
  height: 100%;
}
</style>
